import {
  Accordion as MuiAccordion,
  AccordionSummary as MuiAccordionSummary,
  AccordionDetails as MuiAccordionDetails,
  AccordionProps,
  AccordionSummaryProps,
  AccordionDetailsProps,
  SxProps,
} from '@mui/material';

// Make it separate style due to the design not using
// MUI pattern, will change in future
const borderlessStyles: SxProps = {
  boxShadow: 'none',
  paddingBottom: '0',
  borderBottom: '1px solid #dedede',
  '.MuiButtonBase-root': {
    padding: 0,
  },
  '&.MuiPaper-root:before': {
    display: 'none',
  },
  '.MuiTypography-root': {
    fontWeight: '500',
    marginBottom: 0,
  },
  '.MuiAccordionDetails-root': {
    padding: '0',
  },
  '.MuiCollapse-root .MuiCollapse-wrapperInner': {
    paddingBlock: '4px 16px',
  },
};

interface IAccordionProps extends AccordionProps {
  borderless?: boolean;
}

export const Accordion = ({ borderless = false, sx, ...rest }: IAccordionProps) => (
  <MuiAccordion sx={{ ...(borderless && borderlessStyles), ...sx }} {...rest} />
);
export const AccordionSummary = ({ ...rest }: AccordionSummaryProps) => (
  <MuiAccordionSummary {...rest} />
);
export const AccordionDetails = ({ ...rest }: AccordionDetailsProps) => (
  <MuiAccordionDetails {...rest} />
);
